// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingSpinner_loadingContainer__1927H","spinner":"LoadingSpinner_spinner__2s3zP"};